export default __webpack_public_path__ + "static/LSJH-logo-de1f2fa3536821b5544c683ebe4845dd.png";